import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout, Button, message, Form, Input } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import { getMemberDigitalApi } from "../../services/Member/MemberApis";
import { authenticateMemberOTPApi } from "../../services/Member/MemberApis";

const { Content } = Layout;

const MemberOTPPage: React.FC = () => {
  const navigate = useNavigate();
  const { memberId }: any = useParams();

  const [isActive, setActive] = useState(true);
  const [otp, setOtp] = useState("");
  const [member, setMember] = useState<any>({});

  useEffect(() => {
    getMemberDigitalApi(String(memberId))
      .then((res: any) => {
        setMember(res.data);
        setActive(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [memberId]);

  const handleAuthenticate = async () => {
    if (otp) {
      authenticateMemberOTPApi(memberId, { Otp: otp })
        .then((res) => {
          if (res.success) {
            navigate(`/members/signature/${memberId}`);
            setActive(false);
          } else {
            message.error("Incorrect OTP, Please try again.");
          }
        })
        .catch((err) => {
          console.log(err);
          setActive(false);
        });
    } else {
      message.warning("Please provide an OTP before saving.");
    }
  };

  return (
    <LoadingOverlay active={isActive} spinner={<LoadingOutlined />}>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout className="site-layout">
          <Content
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              background: "#fff",
              padding: "24px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                width: "100%",
                maxWidth: "500px",
                padding: "16px",
                boxSizing: "border-box",
              }}
            >
              {member.Group?.CompanyLogo && (
                <img
                  src={member.Group.CompanyLogo}
                  alt="Group Logo"
                  style={{
                    marginBottom: "24px",
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              )}
              <h3
                style={{
                  marginBottom: "24px",
                  padding: "0 16px",
                  fontSize: "1.1em",
                  lineHeight: "1.5",
                }}
              >
                To continue with your application for a funeral policy with{" "}
                {member?.Group?.GroupName}, please enter the One-Time Password
                (OTP) sent to your registered contact number.
              </h3>
              <Form.Item
                name="Otp"
                rules={[{ required: true, message: "Please input your OTP" }]}
                style={{ marginBottom: "16px" }}
              >
                <Input
                  onChange={(e) => setOtp(e.target.value)}
                  size="large"
                  placeholder="OTP"
                />
              </Form.Item>
              <Button
                type="primary"
                size="large"
                onClick={handleAuthenticate}
                style={{ width: "100%", marginTop: "16px" }}
              >
                Submit
              </Button>
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default MemberOTPPage;
